<template>
    <div id="header-section">
        <header class="fixed-top z-index-100">

            <!-- Navbar Top -->
            <nav v-if="!isIframe && !currentUserLoading" class="bg-primary padding-2">
                <div class="px-2 my-1 row justify-content-center">
                    <div class="col-auto text-center">
                        <span class="nav-item">
                            <a href="https://www.ultimatejetvacations.com/hotels/oneonly-palmilla" target="_blank" class="font-sm link-style-white3">
                                <span class="d-none d-sm-inline-block font-sm link-style-white3">Discover our Partner of the Month: Kerzner International</span>
                            </a>
                        </span>
                    </div>
                </div>
            </nav>
            <nav v-if="!isIframe && !currentUserLoading" class="navbar navbar-light bg-light navbar-top-big">
                <div class="row w-100 margin-0 justify-content-center">

                    <!-- Bars and Phone -->
                    <div class="navbar-left-group">
                        <button class="navbar-toggler collapsed d-block d-md-none" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar top-bar"></span>
                            <span class="icon-bar middle-bar"></span>
                            <span class="icon-bar bottom-bar"></span>
                        </button>

                        <span class="cursor-pointer nav-link d-none d-md-block">
                            <span class="align-middle material-icons margin-top-5">menu</span>
                        </span>

                        <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" :href="companyInfo.tollFreePhone.getURI()" style="padding-top: 14px">
                            <i class="align-middle material-icons">phone</i>
                            <span class="d-none d-xl-inline-block">{{ companyInfo.tollFreePhone.formatInternational() }}</span>
                        </a>
                    </div>

                    <!-- Logo and Mini Menu -->
                    <ul class="text-center margin-0 d-none d-md-inline-block margin-top-5">
                        <router-link tag="li" :to="{name: 'hotels'}" class="float-left nav-item">
                            <a class="nav-link nav-link-top text-uppercase font-weight-bold font-sm text-secondary">Hotels</a>
                        </router-link>
                        <router-link tag="li" :to="{name: 'destinations'}" class="float-left nav-item">
                            <a class="nav-link nav-link-top text-uppercase font-weight-bold font-sm text-secondary">Destinations</a>
                        </router-link>
                        
                    </ul>
                    <a class="col-auto navbar-brand" href="/">
                        <picture>
                            <source media="(min-width: 1330px)" srcset="/assets/brand/ultimate-jet-vacations-logo-dark.svg">
                            <source srcset="/assets/brand/ultimate-jet-vacations-star-logo.svg">
                            <img height="50" src="/assets/brand/ultimate-jet-vacations-logo-dark.svg" alt="Ultimate Jet Vacations Logo">
                        </picture>
                    </a>
                    <ul class="text-center margin-0 d-none d-md-inline-block margin-top-5">
                        <!--<router-link tag="li" :to="{name: 'africa'}" class="float-left nav-item d-none display-xl-inline-block">
                            <a class="nav-link nav-link-top text-uppercase font-weight-bold font-sm text-secondary" id="link-africa">New: Africa Portfolio</a>
                        </router-link>-->
                        <li class="float-left nav-item d-none display-xl-inline-block">
                            <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" href="https://festiveavailability.ultimatejetvacations.com" target="_blank">Festive Availability</a>
                        </li>
                                                                     
                        <li class="float-left nav-item">
                            <a href="https://landing.ultimatejetvacations.com/ujvreferral" target="_blank" class="nav-link text-uppercase font-weight-bold font-sm text-secondary">Referral Program</a>
                        </li>

                    </ul>
                    <!-- Search and Get a Quote -->
                    <div class="navbar-right-group">
                        <a class="nav-link font-sm text-secondary" href="#" v-on:click.prevent="showPanelSearch"><i class="align-middle material-icons">search</i></a>
                        <div class="nav-item nav-bt">
                            <div v-if="currentUser" class="d-none d-xl-inline">
                                <get-quote-button :get-component-from-uri="true"></get-quote-button>
                            </div>
                        </div>
                        <a v-if="currentUser" class="nav-link font-sm icon-action d-xl-none" href="#" v-on:click.prevent="showPanelQuote"><i class="align-middle material-icons">monetization_on</i></a>
                    </div>

                    <!-- Dropdown Full Menu -->
                    <div class="col-auto collapse navbar-collapse navbar-full-menu" id="navbarNav">
                        <div class="container padding-0" style="max-width: 1040px">
                            <div class="navbar-full-menu-cont-1">
                                <div class="row justify-content-center">
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <ul>
                                            <li class="nav-item">
                                                <a href="/" class="nav-link text-uppercase font-weight-bold font-sm text-secondary">Home</a>
                                            </li>
                                            <router-link tag="li" :to="{name: 'hotels'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Hotels</a>
                                            </router-link>
                                            <router-link tag="li" :to="{name: 'destinations'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Destinations</a>
                                            </router-link>
                                            <!--<li class="nav-item">
                                                <a href="https://oo.ultimatejetvacations.com/optin1659015908495" target="_blank" class="nav-link nav-link-top text-uppercase font-weight-bold font-sm text-secondary">UJV Rewards Program</a>
                                            </li>-->
                                            <li class="nav-item">
                                                <a href="https://landing.ultimatejetvacations.com/ujvreferral" target="_blank" class="nav-link nav-link-top text-uppercase font-weight-bold font-sm text-secondary">Referral Program</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <ul>
                                            <li class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary display-xl-none" href="https://festive.ultimatejetvacations.com/ujv-festive-availability" target="_blank">Festive Availability</a>
                                            </li>
                                            <router-link tag="li" :to="{name: 'festive-tool'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Festive Trends</a>
                                            </router-link>
                                            <router-link tag="li" :to="{name: 'concierge'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Concierge</a>
                                            </router-link>

                                            <li class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" href="https://landing.ultimatejetvacations.com/ujv-webinar-library">Webinar Library</a>
                                            </li>

                                            <router-link tag="li" :to="{name: 'map'}" class="nav-item display-not-xl-none">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Map</a>
                                            </router-link>
                                        </ul>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <ul>
                                            <router-link tag="li" :to="{name: 'careers'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Career Opportunities</a>
                                            </router-link>
                                            <li class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" href="https://docs.google.com/document/d/13DeRqNYJpXvTmru4k7JIpv391sZ3C9L5I-p1Iy0S0ug/edit?usp=sharing" target="_blank">Hotel Portfolio</a>
                                            </li>
                                            <router-link tag="li" :to="{name: 'trending'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Trending Now</a>
                                            </router-link>
                                            <router-link tag="li" :to="{name: 'flights'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Flights</a>
                                            </router-link>
                                        </ul>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <ul>
                                            <router-link tag="li" :to="{name: 'map'}" class="nav-item display-xl-none">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">Map</a>
                                            </router-link>
                                            <router-link tag="li" :to="{name: 'faq'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">FAQ</a>
                                            </router-link>
                                            <router-link tag="li" :to="{name: 'about-us'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">About us</a>
                                            </router-link>
                                            <router-link v-if="currentUser" tag="li" :to="{name: 'profile'}" class="nav-item">
                                                <a class="nav-link text-uppercase font-weight-bold font-sm text-secondary" data-toggle="collapse" data-target="#navbarNav">My bucket</a>
                                            </router-link>
                                            <li class="nav-item">
                                                <a href="/app/dashboard" class="nav-link text-uppercase font-weight-bold font-sm text-secondary">Dashboard</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="navbar-full-menu-cont-2">
                                <div class="row">
                                    <div class="text-left col-12 col-md-4 text-md-left margin-bottom-10">
                                        <a class="link-style text-secondary" href="tel:3058300200">Phone: 305-830-0200</a>
                                    </div>
                                    <div class="text-left col-12 col-md-4 text-md-center margin-bottom-10">
                                        <a class="link-style text-secondary" :href="companyInfo.tollFreePhone.getURI()">Reservations: {{ companyInfo.tollFreePhone.formatInternational() }}</a>
                                    </div>
                                    <div class="text-left col-12 col-md-4 text-md-right margin-bottom-10">
                                        <a class="link-style text-secondary" href="mailto:info@ultimatejetvacations.com">info@ultimatejetvacations.com</a>
                                    </div>
                                </div>
                                <div class="d-none d-sm-block row margin-top-20 margin-bottom-20">
                                    <div class="col-12 social-media-dark-icons">
                                        <section-social-media></section-social-media>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <!-- Navbar Bottom -->
            <nav class="navbar navbar-expand navbar-dark bg-secondary navbar-top-small">
                <ul class="m-auto navbar-nav">

                    <!-- User Name -->
                    <span v-if="currentUser">
                        <router-link tag="li" :to="{name: 'profile'}" exact class="nav-item nav-item-separator-r">
                            <a class="nav-link text-uppercase font-weight-bold font-sm white">
                            <span>
                                <span class="d-block d-md-none"><i class="align-middle material-icons">person_outline</i></span>
                                <span class="d-none d-md-inline-block">Hello {{currentUser.first_name}} {{currentUser.last_name.charAt(0)}}.</span>
                            </span>
                            </a>
                        </router-link>
                    </span>

                    <span v-if="isIframe && !currentUserLoading">
                        <router-link tag="li" :to="{name: 'destinations'}" exact class="nav-item nav-item-separator-r">
                            <a class="nav-link text-uppercase font-weight-bold font-sm white">
                                <span class="inline-block">Destinations</span>
                            </a>
                        </router-link>
                    </span>

                    <span v-if="isIframe && !currentUserLoading">
                        <router-link tag="li" :to="{name: 'hotels'}" exact class="nav-item nav-item-separator-r">
                            <a class="nav-link text-uppercase font-weight-bold font-sm white">
                                <span class="inline-block">Hotels</span>
                            </a>
                        </router-link>
                    </span>

                    <!-- My Bucket and Dashborad -->
                    <span v-if="currentUser">
                        <li class="nav-item">
                            <a href="/app/dashboard" class="nav-link text-uppercase font-weight-bold font-sm white" style="color: #ffad56 !important;">
                                <i class="text-white align-middle material-icons">dashboard</i> <span class="d-none d-md-inline-block">ACCESS YOUR BOOKINGS</span>
                            </a>
                        </li>
                    </span>
                    <span v-if="currentUser">
                        <router-link v-if="!currentUserLoading" tag="li" :to="{name: 'profile'}" class="nav-item">
                            <a class="nav-link text-uppercase font-weight-bold font-sm white">
                                <i class="text-white align-middle material-icons">favorite</i> <span class="d-none d-md-inline-block">My buckets</span>
                            </a>
                        </router-link>
                    </span>

                    <!-- Logout -->
                    <span v-if="currentUser">
                        <li v-if="!currentUserLoading" class="nav-item nav-item-separator-l">
                            <a class="cursor-pointer nav-link text-uppercase font-weight-bold font-sm white" @click="logout">
                                <span class="d-block d-md-none"><i class="material-icons">exit_to_app</i></span>
                                <span class="d-none d-md-inline-block">Logout</span>
                            </a>
                        </li>
                    </span>

                    <!-- Login -->
                    <span v-if="!currentUser">
                        <li v-if="!currentUserLoading" class="nav-item nav-item-separator-r">
                            <a class="nav-link text-uppercase font-weight-bold font-sm white" href="/login">Login</a>
                        </li>
                    </span>

                    <!-- Register -->
                    <span v-if="!currentUser">
                        <li v-if="!currentUserLoading" class="nav-item">
                            <a class="nav-link text-uppercase font-weight-bold font-sm white" href="/sign-up">Register</a>
                        </li>
                    </span>

                    <!-- Loader -->
                    <li v-if="currentUserLoading" class="nav-item">
                        <dots-loader :loader-style="'font-size: 25px; line-height: 25px'" class="mr-3"></dots-loader>
                    </li>
                </ul>
            </nav>
        </header>

        <form id="logout-form" action="/logout" method="POST" class="d-none">
            <input type="hidden" name="_token" ref="logoutToken" value="">
        </form>

    </div>
</template>

<script>
    import SectionSocialMedia from './SocialMedia';
    import { vueSlideoutPanelService } from 'vue2-slideout-panel';
    import { mapGetters } from "vuex"
    import GetQuoteSidebar from "../sidebars/GetQuoteSidebar";
    import SearchSidebar from "../sidebars/SearchSidebar";
    import DotsLoader from "../misc/DotsLoader";
    import GetQuoteButton from "../misc/GetQuoteButton";
    import isEmpty from 'lodash/isEmpty';

    const preserveQueryParams = (to, from, next) => {
        const usePreviousQueryParams = isEmpty(to.query) && !isEmpty(from.query);
        if (usePreviousQueryParams && from.query.iframe) {
            next({ ...to, query: from.query });
        } else {
            next();
        }
    };

    export default {
        components: { SectionSocialMedia, DotsLoader, GetQuoteButton },

        created() {
            this.initialize();
        },
        mounted() {
            this.removeBeforeEachRouteGuard = this.$router.beforeEach(preserveQueryParams);
        },
        destroyed() {
            this.removeBeforeEachRouteGuard();
            this.$router.push({ query: undefined });
        },
        computed: {
            ...mapGetters({
                currentUser: "Auth/user",
                currentUserLoading: "Auth/loading",
                dataInitialized: "Data/initialized",
            }),
            isIframe() {
                return !!this.$route.query.iframe;
            },
        },

        data() {
            return {
                companyInfo: this.$store.getters["Company/companyInfo"],
            }
        },

        methods: {
            initialize() {
                this.$store.dispatch("Auth/fetchUser");
            },

            logout() {
                this.$refs.logoutToken.value = document.querySelector("meta[name=csrf-token]").getAttribute("content");
                document.getElementById('logout-form').submit();
            },

            showPanelQuote() {
                vueSlideoutPanelService.show({
                    width: 550,
                    component: GetQuoteSidebar,
                });
            },

            showPanelSearch() {
                vueSlideoutPanelService.show({
                    width: 550,
                    component: SearchSidebar
                });
            },
        },
    };
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
    #link-africa {
        background: linear-gradient(to right, #0071bc, #0071bc, #0071bc, #0071bc, #0071bc);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: animafrica 2s infinite;
        /*text-shadow: 0 0 0 yellow: */
    }
    #link-africa:hover{
        color: blue;
    }
    @keyframes animafrica {
        5% {
            background: linear-gradient(to right, #fff, #0071bc, #0071bc, #0071bc, #0071bc);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        10% {
            background: linear-gradient(to right, #0071bc, #fff, #0071bc, #0071bc, #0071bc);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        15% {
            background: linear-gradient(to right, #0071bc, #0071bc, #fff, #0071bc, #0071bc);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        20% {
            background: linear-gradient(to right, #0071bc, #0071bc, #0071bc, #fff, #0071bc);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        25% {
            background: linear-gradient(to right, #0071bc, #0071bc, #0071bc ,#0071bc, #0071bc, #fff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        30% {
            background: linear-gradient(to right, #0071bc, #0071bc, #0071bc ,#0071bc, #0071bc, #0071bc);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
</style>
